import {
    LayoutDashboard,
    Map as MapIcon,
    Truck,
    ShoppingCart,
    Box,
    Star,
    Utensils,
    Factory,
    Wheat,
    Building2,
    ClipboardList,
    ChefHat,
    CheckSquare,
    Users,
    Settings,
    Database,
    FileText,
    TrendingUp,
    CreditCard,
    Printer,
    ShieldAlert,
    Landmark,
    Brain
} from 'lucide-react';

export interface NavigationItem {
    label: string;
    route: string;
    icon?: any;
    badge?: string; // e.g. "WO-1005"
    requiredRoles?: string[];
}

export interface NavigationGroup {
    title: string; // e.g. "Command Center"
    items: NavigationItem[];
    requiredRoles?: string[];
}

export const NAVIGATION_CONFIG: NavigationGroup[] = [
    {
        title: "Command Center",
        items: [
            { label: "Dashboard", route: "/", icon: LayoutDashboard },
            { label: "Live Map (Watchtower)", route: "/logistics/map", icon: MapIcon, badge: "NEW" },
            { label: "Fleet Monitor", route: "/logistics", icon: Truck },
        ]
    },
    {
        title: "Omnichannel",
        requiredRoles: ['super_admin'],
        items: [
            { label: "Intake (Manual)", route: "/omnichannel/intake", icon: ClipboardList, requiredRoles: ['super_admin'] },
            { label: "Draft Review", route: "/admin/drafts", icon: CheckSquare, badge: "NEW", requiredRoles: ['super_admin'] },
            { label: "AI Flywheel", route: "/admin/ai-flywheel", icon: Brain, badge: "HITL", requiredRoles: ['super_admin'] },
        ]
    },
    {
        title: "Menu & Nutrition",
        items: [
            { label: "Products", route: "/products", icon: Box },
            { label: "Categories", route: "/categories", icon: Box },
            { label: "Reviews", route: "/reviews", icon: Star },
        ]
    },
    {
        title: "Manufacturing",
        items: [
            { label: "Active Batches", route: "/production/active", icon: Factory },
            { label: "Ingredients", route: "/ingredients", icon: Wheat },
            { label: "Suppliers", route: "/suppliers", icon: Building2 },
            { label: "Purchase Orders", route: "/purchase-orders", icon: ClipboardList },
            { label: "Stocktake", route: "/inventory/production", icon: ClipboardList },
        ]
    },
    {
        title: "Fulfillment",
        items: [
            { label: "Action Required", route: "/action-required", icon: ShieldAlert, badge: "NEW" },
            { label: "Kitchen (KDS)", route: "/kitchen", icon: ChefHat },
            { label: "QC Station", route: "/qc-packing", icon: CheckSquare },
            { label: "HACCP Safety Radar", route: "/admin/food-safety/haccp", icon: ShieldAlert, badge: "QC" },
            { label: "Dispatch Console", route: "/dispatch", icon: Truck },
            { label: "Orders", route: "/orders", icon: ShoppingCart },
        ]
    },
    {
        title: "Analysis",
        items: [
            { label: "Reports", route: "/reports", icon: TrendingUp },
            { label: "Transactions", route: "/transactions", icon: CreditCard },
            { label: "Settlement Recon", route: "/finance/settlements", icon: Landmark, badge: "NEW" },
        ]
    },
    {
        title: "Team & Config",
        items: [
            { label: "Users", route: "/users", icon: Users },
            { label: "Settings", route: "/settings", icon: Settings },
            { label: "Database", route: "/system/database", icon: Database },
        ]
    }
];
